// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__36dws","header":"ReportDetails_header__sP4sK","title":"ReportDetails_title__3wKJx","left":"ReportDetails_left__3a8Dx"};